import axios from "../lib/axios";

// Create Event Registration (Public)
export const createEventRegistration = async (payload) => {
  try {
    const response = await axios.post("/event-registration/register", payload);
    return response.data;
  } catch (error) {
    throw new Error(
      error?.response?.data?.message || "Failed to create event registration"
    );
  }
};

// Get All Event Registrations (Protected)
export const getAllEventRegistrations = async (params = {}) => {
  try {
    const response = await axios.get("/event-registration", { params });
    return response.data;
  } catch (error) {
    throw new Error(
      error?.response?.data?.message || "Failed to fetch event registrations"
    );
  }
};

// Get Event Registration by ID (Protected)
export const getEventRegistrationById = async (id) => {
  try {
    const response = await axios.get(`/event-registration/${id}`);
    return response.data;
  } catch (error) {
    throw new Error(
      error?.response?.data?.message || "Failed to fetch event registration"
    );
  }
};

// Delete Event Registration (Protected)
export const deleteEventRegistration = async (id) => {
  try {
    const response = await axios.delete(`/event-registration/${id}`);
    return response.data;
  } catch (error) {
    throw new Error(
      error?.response?.data?.message || "Failed to delete event registration"
    );
  }
};

export const downloadEventRegistrations = async () => {
  try {
    const response = await axios.get(
      "/event-registration/export",
      { responseType: "blob" } // Config object for GET
    );

    const blob = new Blob([response.data], {
      type:
        response.headers["content-type"] ||
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;

    // Extract filename from Content-Disposition header
    const contentDisposition = response.headers["content-disposition"];
    let fileName = `event_registrations_${Date.now()}.xlsx`;

    if (contentDisposition) {
      const fileNameMatch = contentDisposition.match(
        /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
      );
      if (fileNameMatch && fileNameMatch[1]) {
        fileName = fileNameMatch[1].replace(/['"]/g, "");
      }
    }

    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);

    return { success: true, fileName };
  } catch (error) {
    console.error("Download error:", error);

    // Handle blob error responses
    if (error?.response?.data instanceof Blob) {
      const text = await error.response.data.text();
      try {
        const errorData = JSON.parse(text);
        throw new Error(errorData.message || "Failed to download file");
      } catch {
        throw new Error("Failed to download file");
      }
    }

    throw new Error(
      error?.response?.data?.message ||
        error?.message ||
        "Failed to download file"
    );
  }
};
